import { render, staticRenderFns } from "./nSwitchcomponent.vue?vue&type=template&id=48b2561f&scoped=true"
import script from "./nSwitchcomponent.vue?vue&type=script&lang=ts"
export * from "./nSwitchcomponent.vue?vue&type=script&lang=ts"
import style0 from "./nSwitchcomponent.vue?vue&type=style&index=0&id=48b2561f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b2561f",
  null
  
)

export default component.exports